import { render, staticRenderFns } from "./DnsFilterTopTable.vue?vue&type=template&id=bd638aa4&"
import script from "./DnsFilterTopTable.vue?vue&type=script&lang=js&"
export * from "./DnsFilterTopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports